<div class="login-box">
  <mat-icon class="user-icon">lock</mat-icon>

  <h1 class="login-heading">¿Has olvidado tu contraseña?</h1>
  <p class="login-description">
    Ingrese la dirección de correo electrónico que utilizó cuando se unió y le
    enviaremos instrucciones para restablecer su contraseña.
  </p>

  <p class="login-description">
    Por razones de seguridad, NO almacenamos su contraseña, por lo que puede
    estar seguro de que nunca le enviaremos su contraseña por correo
    electrónico.
  </p>

  <form
    [formGroup]="forgotPasswordForm"
    class="login-form"
    (ngSubmit)="onSubmit()"
  >
    <mat-form-field appearance="outline" class="input-field">
      <mat-label>Email</mat-label>
      <input
        matInput
        id="email"
        formControlName="email"
        placeholder="Ingrese su usuario"
      />
    </mat-form-field>

    <div class="buttons">
      <button
        mat-raised-button
        style="background-color: #ffa600; color: white; padding: 0.5rem 1rem"
        class="submit-button"
        [disabled]="forgotPasswordForm.invalid || isSubmitting"
        [ngClass]="{ disabled: forgotPasswordForm.invalid || isSubmitting }"
      >
        <ng-container *ngIf="isLoading$ | async">
          <span class="indicator-progress">
            Por favor espere...
            <p-progressSpinner
              [style]="{ width: '1.5rem', height: '1.5rem' }"
              animationDuration="1.5s"
              aria-label="Cargando"
            ></p-progressSpinner>
          </span>
        </ng-container>
        <ng-container *ngIf="!(isLoading$ | async)">
          <span class="indicator-label"
            >Enviar instrucciones de recuperación</span
          >
        </ng-container>
      </button>
      <button
        mat-button
        style="
          background-color: transparent;
          color: #ffa600;
          padding: 0.5rem 1rem;
        "
        class="back-button"
        (click)="goToLogin()"
      >
        Volver
      </button>
    </div>
  </form>
</div>
